var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('DocumentEditor',{attrs:{"fields":_vm.fields,"performDocumentSave":_vm.saveDocument},model:{value:(_vm.document),callback:function ($$v) {_vm.document=$$v},expression:"document"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }